import {Pipe, PipeTransform} from '@angular/core';
import {AuditLogVO} from '../../../generate/AuditLogVO';

@Pipe({
    name: 'auditLogTitleHelper',
    standalone: false
})
export class AuditLogTitleHelperPipe implements PipeTransform {

  transform(log: AuditLogVO, ...args: any[]): any {

    if (args[0] === 'icon') {
      return this.defineIcon(log.type);
    }
  }

  private defineIcon(type: string) {
    switch (type) {
      case 'assignee':
        return "user";
      case 'authorization_sent':
      case 'impacted_party_sent':
      case 'notification_recieved':
        return "envelope-open-text";
      case 'workflow_step':
        return "exchange-alt";
      case 'create':
        return "ticket-alt";
      case 'priorityType':
        return "pen";
      default:
        return 'tablet-alt';
    }
  }

}
